import { type RouteRecordRaw } from 'vue-router'

import { useMapStore } from './store/map.store'
import { useMapsStore } from './store/maps.store'

export const MapRouter: RouteRecordRaw[] = [
  {
    path: '/maps',
    component: async () => import('./MapsList.vue'),
    async beforeEnter() {
      await useMapsStore.getState().list()
    },
  },
  {
    path: '/maps/:id',
    component: async () => import('./Map.vue'),
    props: (route) => ({
      mapOid: route.params.id as string,
    }),
    async beforeEnter(to) {
      useMapStore.getState().load()
      await Promise.all([
        useMapStore.getState().getMap({ id: to.params.id as string }),
        useMapStore.getState().getMapEntityChoices(),
      ])
    },
  },
]
